import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
} from '@mui/material';
import {
  Psychology as BrainIcon,
  RestaurantMenu as MenuIcon,
  Celebration as PartyIcon,
  EmojiEmotions as EmojiIcon,
  TipsAndUpdates as TipsIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';
import { SafeAreaView } from '../layout/SafeAreaView';
import { TopBar } from '../layout/TopBar';

export const HostlyAIPage: React.FC = () => {
  const { theme } = useTheme();

  const aiFeatures = [
    {
      title: 'Assistente IA',
      description: 'Assistente inteligente para ajudar no planejamento de eventos',
      icon: <BrainIcon sx={{ fontSize: 48, color: theme.colors.primary }} />,
      comingSoon: true,
    },
    {
      title: 'Sugestões de Menu',
      description: 'Recomendações personalizadas de pratos baseadas em suas receitas',
      icon: <MenuIcon sx={{ fontSize: 48, color: theme.colors.primary }} />,
      comingSoon: true,
    },
    {
      title: 'Combinações de Louças',
      description: 'Sugestões de harmonização de louças para seu evento',
      icon: <PartyIcon sx={{ fontSize: 48, color: theme.colors.primary }} />,
      comingSoon: true,
    },
    {
      title: 'Dicas de Etiqueta',
      description: 'Orientações de etiqueta social para diferentes tipos de eventos',
      icon: <EmojiIcon sx={{ fontSize: 48, color: theme.colors.primary }} />,
      comingSoon: true,
    },
    {
      title: 'Análise de Preferências',
      description: 'Análise inteligente das preferências dos seus convidados',
      icon: <TipsIcon sx={{ fontSize: 48, color: theme.colors.primary }} />,
      comingSoon: true,
    },
  ];

  return (
    <SafeAreaView>
      <TopBar title="Hostly AI" showBackButton />
      <Box sx={{ p: 2, pb: 8 }}>
        <Box
          sx={{
            textAlign: 'center',
            mb: 4,
            p: 3,
            backgroundColor: `${theme.colors.primary}15`,
            borderRadius: theme.radii.large,
          }}
        >
          <BrainIcon sx={{ fontSize: 64, color: theme.colors.primary, mb: 2 }} />
          <Typography variant="h5" sx={{ color: theme.colors.text.primary, fontWeight: 700, mb: 1 }}>
            Inteligência Artificial Hostly
          </Typography>
          <Typography variant="body2" sx={{ color: theme.colors.text.secondary, mb: 2 }}>
            Recursos avançados de IA para tornar seus eventos ainda mais especiais
          </Typography>
          <Chip
            label="🚀 Disponível em breve para assinantes Pro"
            sx={{
              backgroundColor: theme.colors.secondary,
              color: theme.colors.text.primary,
              fontWeight: 600,
            }}
          />
        </Box>

        <Grid container spacing={2}>
          {aiFeatures.map((feature, index) => (
            <Grid key={index} size={12}>
              <Card
                sx={{
                  backgroundColor: theme.colors.card,
                  borderRadius: theme.radii.medium,
                  border: `1px solid ${theme.colors.border}`,
                  position: 'relative',
                  overflow: 'visible',
                }}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                    <Box
                      sx={{
                        p: 1.5,
                        backgroundColor: `${theme.colors.primary}15`,
                        borderRadius: theme.radii.medium,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            color: theme.colors.text.primary,
                            fontWeight: 600,
                          }}
                        >
                          {feature.title}
                        </Typography>
                        {feature.comingSoon && (
                          <Chip
                            icon={<LockIcon sx={{ fontSize: 16 }} />}
                            label="Em breve"
                            size="small"
                            sx={{
                              backgroundColor: theme.colors.background,
                              color: theme.colors.text.secondary,
                              fontSize: '0.65rem',
                              height: 20,
                            }}
                          />
                        )}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: theme.colors.text.secondary,
                          lineHeight: 1.5,
                        }}
                      >
                        {feature.description}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            mt: 4,
            p: 3,
            backgroundColor: theme.colors.card,
            borderRadius: theme.radii.large,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ color: theme.colors.text.secondary, mb: 1 }}>
            💡 Essas funcionalidades estão em desenvolvimento e estarão disponíveis em breve para assinantes do plano Pro
          </Typography>
          <Typography variant="caption" sx={{ color: theme.colors.text.secondary }}>
            Fique de olho nas próximas atualizações do Hostly!
          </Typography>
        </Box>
      </Box>
    </SafeAreaView>
  );
};
